import Row from "react-bootstrap/Row";
// import Col from "react-bootstrap/Col";

// function genChiefCardV(item) {
//     return (
//         <Col
//             key={item.e_mail}
//             className="staffHolder"
//             data-aos="fade-up"
//             md={12}
//             lg={12}
//             // data-aos-delay="300"
//         >
//             <div className="col-lg-7 mx-auto">
//                 <div className="card mb-5 shadow">
//                     <div className="card-body">
//                         <div className="col-12 col-md-auto text-center">
//                             <img
//                                 src={item.personnelPhoto}
//                                 alt={`${item.fistNameEn} ${item.lastNameEn}`}
//                                 className="personImageV"
//                             />
//                         </div>
//                         <div className="col text-center">
//                             {/* <h3 className="title">{item.position}</h3> */}
//                             <div className="personNameV text-nowrap">
//                                 <span className="me-3">
//                                     {item.titlePosition} {item.firstName}
//                                 </span>
//                                 <span>{item.lastName}</span>
//                             </div>
//                             <div className="positionTitleV">
//                                 {item.adminPosition
//                                     ? item.adminPosition
//                                     : item.position}
//                             </div>
//                             <div className="personContactV">
//                                 <span className="email">
//                                     <i className="bi bi-envelope-at"></i>
//                                     {item.e_mail}
//                                 </span>
//                                 <span className="phone">
//                                     <i className="bi bi-telephone"></i>
//                                     {"053 875 350"}
//                                 </span>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </Col>
//     );
// }

function genCardV(item, strSubTitle = null, strSubTitleEn = null) {
    const genPosition = (item, position) => {
        let output = "";
        // console.log(strSubTitle);
        if (strSubTitle.startsWith("ผู้อำนวยการ")) {
            output = item.adminPositionType;
        } else {
            // output += position ? position : item.position;
            output += item.position;
            output += item.positionLevel ? " (" + item.positionLevel + ")" : "";
        }

        return output;
    };

    return (
        <div
            key={item.e_mail}
            className="staffHolder"
            data-aos="fade-up"
            // data-aos-delay="300"
        >
            <div className="card mb-5 shadow">
                <div className="card-body">
                    <div className="col-12 col-md-auto text-center">
                        <img
                            src={item.personnelPhoto}
                            alt={`${item.fistNameEn} ${item.lastNameEn}`}
                            className="personImageV"
                        />
                    </div>
                    <div className="col text-center">
                        {/* <h3 className="title">{item.position}</h3> */}
                        <div className="personNameV text-nowrap">
                            <div>
                                <span className="me-3">{item.firstName}</span>
                                <span>{item.lastName}</span>
                            </div>
                            <div>
                                <span className="me-3">{item.firstNameEn}</span>
                                <span>{item.lastNameEn}</span>
                            </div>
                        </div>
                        <div className="positionTitleV">
                            {genPosition(
                                item,
                                `${strSubTitle}${
                                    strSubTitleEn ? " / " + strSubTitleEn : ""
                                }`
                            )}
                        </div>
                        <div className="personContactV">
                            <span className="email">
                                <i className="bi bi-envelope-at"></i>
                                {item.e_mail}
                            </span>
                            <span className="phone">
                                <i className="bi bi-telephone"></i>
                                {"053 875 350"}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function genCardH(item, courseboard = false) {
    const genPositionTitle = (item, courseboard) => {
        if (courseboard && item.adminBoardOrder) {
            return (
                <span>
                    {item.adminPositionType} / {item.adminPositionTypeEn}
                </span>
            );
        } else if (courseboard && item.courseCommittee) {
            return (
                <span>
                    {item.courseCommittee} / {item.courseCommitteeEn}
                </span>
            );
        } else if (item.adminPositionId === 65) {
            return <span>{item.adminPositionType}</span>;
        } else {
            return <span>{item.position}</span>;
        }
    };
    // console.log("item:", item);
    return (
        <div
            key={item.e_mail}
            className="staffHolder"
            data-aos="fade-up"
            // data-aos-delay="300"
        >
            <div className="card mb-5 shadow" style={{ fontSize: "2rem" }}>
                <div className="card-body p-4 row">
                    <div className="col-12 col-md-auto text-center">
                        <img
                            src={item.personnelPhoto}
                            alt={`${item.fistNameEn} ${item.lastNameEn}`}
                            className="personImageH"
                        />
                    </div>
                    <div className="col text-center">
                        <div
                            style={{ fontSize: "1.5rem" }}
                            className="personNameH"
                        >
                            <div>
                                <span className="me-3">
                                    {item.titlePosition} {item.firstName}
                                </span>
                                <span>{item.lastName}</span>
                            </div>
                            <div className="pt-0">
                                <span className="me-3">
                                    {item.titlePositionEn} {item.firstNameEn}
                                </span>
                                <span>{item.lastNameEn}</span>
                            </div>
                        </div>
                        {/* <div className="positionTitle">{item.adminPosition}</div> */}

                        <div className="positionTitle">
                            {genPositionTitle(item, courseboard)}
                        </div>
                        
                        <span className="email">
                            <i className="bi bi-envelope-at"></i> {item.e_mail}
                        </span>
                        <span className="phone">
                            <i className="bi bi-telephone"></i> {"053 875 350"}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

function genSubTitle(strSubTitle, strSubTitleEn) {
    return (
        <div className="subCategoryTitle">
            {strSubTitle}
            <br />
            <small>{strSubTitleEn}</small>
        </div>
    );
}

export function GenCardsV(props) {
    const { strSubTitle, strSubTitleEn, items, sm, md, lg } = props;
    console.log("strSubTitle:", strSubTitle);
    console.log("items:", items);

    return (
        items &&
        items.length > 0 && (
            <div>
                {genSubTitle(strSubTitle, strSubTitleEn)}
                <Row sm={sm} md={md} lg={lg} className="justify-content-center">
                    {items.map(
                        (item, index) =>
                            genCardV(item, strSubTitle, strSubTitleEn)
                        // index > 0 ? genCardV(item) : genChiefCardV(item)
                    )}
                </Row>
            </div>
        )
    );
}

export function GenCardsH(props) {
    const strSubTitle = props.strSubTitle;
    const strSubTitleEn = props.strSubTitleEn;
    const items = props.items;
    const sm = props.sm;
    const md = props.md;
    const lg = props.lg;
    const courseboard = props.courseboard;
    // console.log("strSubTitle:", items);

    return (
        <div className="col-sm-12 col-md-10 col-lg-8 col-xl-7 mx-auto">
            {strSubTitle ? genSubTitle(strSubTitle, strSubTitleEn) : null}
            <Row sm={sm} md={md} lg={lg} className="justify-content-center">
                {items.map((item) => genCardH(item, courseboard))}
            </Row>
        </div>
    );
}
